const state = () => {
  return {
    cart: []
  };
};
const mutations = {
  SET_CART_ITEMS(state, product) {
    const index = state.cart.findIndex(item => {
      if (item.details) {
        return item.details.id === product.id;
      }
      return -1;
    });
    if (index === -1) {
      state.cart.push({
        details: product,
        qty: 1
      });
    } else {
      state.cart[index].qty++;
    }
  },
  REMOVE_ITEM(state, index) {
    state.cart.splice(index, 1);
  },
  REMOVE_SINGLE_ITEM(state, product_id) {
    const index = state.cart.findIndex(item => {
      return item.details.id === product_id;
    });
    if (state.cart[index].qty <= 1) {
      state.cart.splice(index, 1);
    } else {
      state.cart[index].qty--;
    }
  },
  SET_CART(state, cart) {
    state.cart = cart;
  }
};

const getters = {
  getCart: state => {
    return state.cart;
  }
};
const actions = {
  add(context, product) {
    context.commit('cart/SET_CART_ITEMS', product, { root: true });
  },
  decrement({ commit }, product_id) {
    commit('cart/REMOVE_SINGLE_ITEM', product_id, { root: true });
  },
  remove({ commit }, index) {
    commit('cart/REMOVE_ITEM', index, { root: true });
  },
  setCart({ commit }, cartData) {
    commit('cart/SET_CART', cartData, { root: true });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
